import { useCallback } from 'react'

import { Delete } from '@factorialco/f0-react/icons/app'
import { MyRequestsDataCollectionQuery } from 'generated/resources/graphql'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteTrainingRequest } from 'modules/trainings/hooks/TrainingRequests/useDeleteTrainingRequest'

type RequestNode = NonNullable<
  MyRequestsDataCollectionQuery['trainings']['trainingRequestsConnection']['nodes']
>[number]

export const useActions = () => {
  const { delete: deleteRequest } = useDeleteTrainingRequest()

  const handleDelete = useCallback(
    async (item: RequestNode) => {
      const result = await deleteRequest({ id: item.id })

      const handler = handleResult(result, () => {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('trainings.training_requests.create.wrong'),
        })
      })

      if (handler.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('trainings.training_requests.create.delete'),
        })
      }
    },
    [deleteRequest]
  )

  const itemActions = useCallback(
    (item: RequestNode) =>
      item.status === 'draft'
        ? [
            {
              label: i18n.t('common.delete'),
              icon: Delete,
              variant: 'critical' as const,
              onClick: () => handleDelete(item),
            },
          ]
        : [],
    [handleDelete]
  )

  return { itemActions }
}
